// Body of the Oscar address-book list view: the legacy sealy breadcrumb shell
// ("Your Account / Your Address Book"), the address cards with their
// default-address badges and management links, the pagination, the
// add-address button, and the customer-service info block.
import { Immutable } from "immer";
import React from "react";
import { Pagination } from "tsi-common-react/src/apps/customer-account/Pagination/index";

import { templates } from "@reactivated";

import { AccountBreadcrumbShell } from "../AccountBreadcrumbShell";
import { CustomerServiceInfoBlock } from "../CustomerServiceInfoBlock";

import styles from "./index.module.scss";

type IProps = Immutable<templates.AddressListDocumentTemplate>;

const DefaultBadge = (props: Immutable<{ label: string }>) => (
    <span className={styles.defaultBadge}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z" />
        </svg>
        {props.label}
    </span>
);

export const AddressListPageBody = (props: IProps): React.JSX.Element => (
    <>
        <AccountBreadcrumbShell
            crumbs={[
                { label: "Your Account", href: props.profile_url },
                { label: "Your Address Book" },
            ]}
            heading="Your Address Book"
        >
            <div>
                {props.addresses.length > 0 ? (
                    <>
                        {props.addresses.map((address, i) => (
                            <div className={styles.addressCard} key={i}>
                                <address>
                                    {address.fields.map((field, j) => (
                                        <React.Fragment key={j}>
                                            {field}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </address>

                                {address.is_default_for_shipping && (
                                    <DefaultBadge
                                        label={address.default_shipping_label}
                                    />
                                )}
                                {address.is_default_for_billing && (
                                    <DefaultBadge
                                        label={address.default_billing_label}
                                    />
                                )}

                                <footer>
                                    <a href={address.edit_url}>
                                        {address.edit_label}
                                    </a>
                                    <span>|</span>
                                    <a href={address.delete_url}>
                                        {address.delete_label}
                                    </a>
                                    {address.set_default_shipping_url && (
                                        <>
                                            <span>|</span>
                                            <a
                                                href={
                                                    address.set_default_shipping_url
                                                }
                                            >
                                                {
                                                    address.set_default_shipping_label
                                                }
                                            </a>
                                        </>
                                    )}
                                    {address.set_default_billing_url && (
                                        <>
                                            <span>|</span>
                                            <a
                                                href={
                                                    address.set_default_billing_url
                                                }
                                            >
                                                {
                                                    address.set_default_billing_label
                                                }
                                            </a>
                                        </>
                                    )}
                                </footer>
                            </div>
                        ))}
                        {props.pagination && (
                            <Pagination data={props.pagination} />
                        )}
                    </>
                ) : (
                    <p>{props.empty_message}</p>
                )}

                <a href={props.add_address_url} className="button">
                    {props.add_address_label}
                </a>
            </div>
        </AccountBreadcrumbShell>

        {props.cs_info && <CustomerServiceInfoBlock info={props.cs_info} />}
    </>
);
